export default __webpack_public_path__ + "static/media/Worley_Logo_2019_1000x303_RGB.57169cac.png";